var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overflowable",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',[_c('div',{staticClass:"d-flex mb-2 ml-1"},[_c('add-vehicle'),_c('import-vehicle')],1),_c('vehicle-list')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }